import { api } from '../../lib/api.ts';

export type ManualDocKind = 'QUOTATION' | 'INVOICE';

export interface ManualDoc {
  id: string;
  kind: ManualDocKind;
  fileName: string;
  mime: string;
  size: number;
  sortOrder: number;
  uploadedAt: string;
}

export interface ManualStateAward {
  vendorId: string;
  vendorName: string;
  amount: number;
  sentToFinanceAt: string | null;
  paid: boolean;
}

export interface ManualState {
  mode: 'AUTOMATIC' | 'MANUAL';
  quotations: ManualDoc[];
  invoice: ManualDoc | null;
  award: ManualStateAward | null;
  locked: boolean;
}

export const manualQuoteApi = {
  get: (requestId: string) =>
    api.get<ManualState>(`/requests/${requestId}/manual`).then((r) => r.data),
  uploadDoc: (
    requestId: string,
    body: { kind: ManualDocKind; fileName: string; mime: string; dataBase64: string },
  ) => api.post<{ doc: ManualDoc }>(`/requests/${requestId}/manual/docs`, body).then((r) => r.data.doc),
  deleteDoc: (requestId: string, docId: string) =>
    api.delete(`/requests/${requestId}/manual/docs/${docId}`).then(() => undefined),
  award: (requestId: string, vendorId: string, amount: number) =>
    api.post<{ award: unknown }>(`/requests/${requestId}/manual/award`, { vendorId, amount }).then((r) => r.data),
  sendToFinance: (requestId: string) =>
    api.post<{ award: unknown }>(`/requests/${requestId}/award/send-to-finance`).then((r) => r.data),
};
